<!------------------------------------------------------------------------------
  Copyright (c) 2019. Keni Williams <kenneth.williams@estuk.co.uk>

  This file TicketInfo.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  TicketInfo.vue can not be copied and/or distributed
  without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
  ----------------------------------------------------------------------------->

<template>
    <div>
        <div :class="{
              'row':!info_full_width
            }">
            <div :class="{
                    'col-8':!info_full_width,
                    'mb-3':ticketInfoDescriptionShort || ticketInfoDescriptionLong
                 }">
                <template v-if="ticketInfoDescriptionShort">
                    {{ticketInfoDescriptionShort}}
                </template>
                <div :class="{
            'newspaper':!layout_vertical
            }"
                     v-if="ticketInfoDescriptionLong"
                     v-html="ticketInfoDescriptionLong"></div>
            </div>
            <div :class="{
                'col-4':!info_full_width
            }">
                <ImageResponsive v-if="hasImage"
                                 :image="ticketInfoImage"
                                 :alt="ticket.title"
                                 default_size="md"
                                 :lazy_load="true"
                                 class="mw-100 d-block mx-auto mb-1"
                />
            </div>
        </div>
        <hr class="d-block d-md-none my-0">
    </div>
</template>

<script>
    window.Vue.component('ImageResponsive', require('../images/ImageResponsive'));

    import lang from '../../../../../app/Shared/Resources/Assets/js/helpers/lang';

    export default {
        name: "TicketInfo",
        props: {
            info_full_width: {
                type: Boolean,
                default: true
            },
            layout_vertical: {
                type: Boolean,
                default: true
            },
            ticket: {
                type: Object
            },
        },
        methods: {
            lang(path, object) {
                return lang(path, object)
            },
            is_bundle() {
                return this.ticket.hasOwnProperty('bundle') ? 'bundle' : 'entity';
            }
        },
        computed: {
            hasImage() {
                return typeof this.ticket[this.is_bundle()].images !== 'undefined'
            },
            ticketInfoImage() {
                return this.ticket[this.is_bundle()].images.length > 0 ? this.ticket[this.is_bundle()].images[0] : null
            },
            ticketInfoDescriptionShort() {
                return this.ticket[this.is_bundle()].description_short;

            },
            ticketInfoDescriptionLong() {
                return this.ticket[this.is_bundle()].description_long
            }
        }
    }
</script>

<style scoped>
    .newspaper {
        -webkit-column-gap: 20px;
        -moz-column-gap: 20px;
        column-gap: 20px;
        -webkit-column-count: 2;
        -moz-column-count: 2;
        column-count: 2;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/tickets/TicketInfo.vue